/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = INPROGRESS
 *
 * 1 = CONFIRMED
 *
 * 2 = CANCELLED
 *
 * 3 = INVOICED
 */
export enum SalesOrderStatus {
  INPROGRESS = 0,
  CONFIRMED = 1,
  CANCELLED = 2,
  INVOICED = 3,
}
